<template>
  <div class="m-wap-card" v-if="cardUrl">
    <iframe :src="cardUrl" frameborder="0"></iframe>
  </div>
</template>
<script>
import { URLS } from "fire-wind-water";
import $ from "jquery";
export default {
  name: "Return",
  data() {
    return {
      cardUrl: ""
    };
  },
  methods: {},
  created() {
    this.cardUrl = decodeURIComponent(
      URLS.getURL("cardUrl") || URLS.getHash("cardUrl")
    );
    if (this.cardUrl == "null") {
      this.cardUrl = "";
    }
    window.addEventListener("message", function(e) {
      if (e.data == "hide") {
        $(".m-wap-card").hide();
      }
    });
  }
};
</script>
